import React, { useEffect, useState } from 'react';
import reverseTransaction from '../../assets/icons/reverseTransaction.svg';
import checkcircleUSD from '../../assets/icons/checkcircleUSD.svg';
import ModalApproveUSD from '../Modals/ModalApproveUSD';
import ModalReturnUSD from '../Modals/ModalReturnUSD';
import useUSDRequest from '../../hooks/useUSDRequest';
import { Loader } from '@piggytechng/component-library';
import dayjs from 'dayjs';
// import useRolePermissions from '../../hooks/useRolePermissions';

const USDUserInfo = ({ setShowCommentTab }: { setShowCommentTab: (show: boolean) => void }) => {
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);
  const { singleUSDRequest, isLoadingSingleUSDRequests } = useUSDRequest();
  // const { restrictActionByRole } = useRolePermissions({});

  const execution = {
    text: 'Approve Request',
    action: () => {
      setShowApprovalModal(false);
    },
    buttonText: 'Approve',
    type: '',
    actionColor: '#1734CA',
  };

  const executionReturn = {
    text: 'Return request',
    action: () => {
      setShowApprovalModal(false);
    },
    buttonText: 'Return',
    type: '',
    actionColor: '#1734CA',
  };

  useEffect(() => {
    if (isLoadingSingleUSDRequests) return;
    singleUSDRequest.status.toLowerCase() !== 'approved' && setShowCommentTab(true);
  }, [isLoadingSingleUSDRequests]);

  return (
    <>
      {isLoadingSingleUSDRequests ? (
        <div className="page-loader">
          <Loader color="#0F60D6" />
        </div>
      ) : (
        <div className="flex--1">
          <div className="usd-details--user-info">
            <h1>User Information</h1>

            <div>
              <div className="info-containter flex--2">
                <div className="info-containter-info flex--4">
                  <label>Full Name</label>
                  <p>{singleUSDRequest?.user_full_name}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Status</label>
                  <div
                    className={`status flex--2 ${singleUSDRequest.status.toLowerCase() === 'under review' ? 'underreview' : singleUSDRequest.status}`}
                  >
                    <span>&#8226;</span>
                    <p>{singleUSDRequest?.status}</p>
                  </div>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Review Needed</label>
                  <p>{singleUSDRequest?.review_needed ? 'Yes' : 'No'}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>KYC Type</label>
                  <p>{singleUSDRequest?.kyc_type || 'N/A'}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Email Address</label>
                  <p>{singleUSDRequest?.user_email}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Identity Type</label>
                  <p>{singleUSDRequest?.identity_type}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Identity Number</label>
                  <p>{singleUSDRequest?.identity_number}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Country of Issue</label>
                  <p>{singleUSDRequest?.identity_country}</p>
                </div>
                {singleUSDRequest?.identity_type !== 'National Identity Number' && (
                  <>
                    <div className="info-containter-info flex--4">
                      <label>Issue Date</label>
                      <p>
                        {singleUSDRequest?.identity_issue_date
                          ? dayjs(String(singleUSDRequest?.identity_issue_date)).format('D MMM YYYY')
                          : 'None'}
                      </p>
                    </div>
                    <div className="info-containter-info flex--4">
                      <label>Expiry Date</label>
                      <p>
                        {singleUSDRequest?.identity_expiry_date
                          ? dayjs(String(singleUSDRequest?.identity_expiry_date)).format('D MMM YYYY')
                          : 'None'}
                      </p>
                    </div>
                  </>
                )}
                {singleUSDRequest?.address_street_number && singleUSDRequest?.address_street_name && (
                  <div className="info-containter-info flex--4">
                    <label>Street Address</label>
                    <p>{`${singleUSDRequest?.address_street_number} ${singleUSDRequest?.address_street_name}`}</p>
                  </div>
                )}
                {singleUSDRequest?.address_state && (
                  <div className="info-containter-info flex--4">
                    <label>State</label>
                    <p>{singleUSDRequest?.address_state}</p>
                  </div>
                )}
                {singleUSDRequest?.address_country && (
                  <div className="info-containter-info flex--4">
                    <label>Country</label>
                    <p>{singleUSDRequest?.address_country}</p>
                  </div>
                )}
                {singleUSDRequest?.address_postal_code && (
                  <div className="info-containter-info flex--4">
                    <label>Postal Code</label>
                    <p>{singleUSDRequest?.address_postal_code}</p>
                  </div>
                )}
                <div className="info-containter-info flex--4">
                  <label>Submission Date</label>
                  <p>{dayjs(String(singleUSDRequest?.created_at)).format('D MMM YYYY')}</p>
                </div>
              </div>

              <h1>Financial Information</h1>

              <div className="info-containter flex--2">
                <div className="info-containter-info flex--4">
                  <label>Employment Status</label>
                  <p>{singleUSDRequest?.employment_status}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Occupation</label>
                  <p>{singleUSDRequest?.occupation}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Primary Purpose</label>
                  <p>{singleUSDRequest?.primary_purpose}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Source of Funds </label>
                  <p>{singleUSDRequest?.source_of_funds}</p>
                </div>
                <div className="info-containter-info flex--4">
                  <label>Expected Monthly Inflow</label>
                  <p>{singleUSDRequest?.expected_monthly_inflow.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</p>
                </div>
              </div>
            </div>
          </div>

          {singleUSDRequest?.status?.toLowerCase() === 'under review' && (
            <div className="usd-details--user-info--approve-buttons flex--4">
              <div
                className="pointer details flex--2"
                onClick={() => {
                  // if (restrictActionByRole('usdRequest', 'approve')) return;
                  setShowApprovalModal(true);
                }}
              >
                <img src={checkcircleUSD} />
                <p>Approve Request</p>
              </div>
              <div
                className="pointer details flex--2"
                onClick={() => {
                  // if (restrictActionByRole('usdRequest', 'return')) return;
                  setShowReturnModal(true);
                }}
              >
                <img src={reverseTransaction} />
                <p>Return Request</p>
              </div>
            </div>
          )}
        </div>
      )}

      <ModalApproveUSD modalIsOpen={showApprovalModal} setIsOpen={setShowApprovalModal} {...execution} />
      <ModalReturnUSD modalIsOpen={showReturnModal} setIsOpen={setShowReturnModal} {...executionReturn} />
    </>
  );
};

export default USDUserInfo;
